<div class="credits-container">
  <h1>Credits</h1>

  <div class="creators-section">
    <mat-card class="creator-card">
      <div class="creator-header">
        <app-avatar class="creator-avatar" src="/img/jay.png" alt="Jay"></app-avatar>
        <div class="creator-info">
          <h2>Website Design & Development</h2>
          <h3>Jay</h3>
        </div>
      </div>
      <mat-card-content class="creator-bio">
        <p>Responsible for maintaining the website, making sure you can write scripts and manage your in-game perks, as well as helping to keep the Discord server running smoothly.</p>
      </mat-card-content>
    </mat-card>

    <mat-card class="creator-card">
      <div class="creator-header">
        <app-avatar class="creator-avatar" src="/img/jar_logo.png" alt="Jar"></app-avatar>
        <div class="creator-info">
          <h2>Worlds Created By</h2>
          <h3>Jar</h3>
        </div>
      </div>
      <mat-card-content class="creator-bio">
        <p>Designing and Developing VRChat classics with the support of the community.</p>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="supporters-section">
    <h2>Made Possible By Jar's Patreon Supporters</h2>
    <div #supportersContainer class="supporters-container">
      @if (loading) {
        <div class="loading-container">
          <mat-spinner diameter="40"></mat-spinner>
          <p class="loading-text">Loading supporters...</p>
        </div>
      } @else if (supporters.length === 0) {
        <p class="no-supporters">No supporters found.</p>
      } @else {
        <div class="supporters-list">
          @for (supporter of supporters; track $index) {
            <span 
              class="supporter-name" 
              [style.background]="supporter.color">
              {{ supporter.vrchat_name }}
            </span>
          }
          <div #loadMoreSentinel class="load-more-sentinel">
            @if (loadingMore) {
              <mat-spinner diameter="30"></mat-spinner>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
